(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
$(function () {
    $('.site-nav--has-dropdown').hover(function() {
    $(this).addClass('nav-hover');
  }, function() {
    $(this).removeClass('nav-hover');
  });
});

  } catch(e) { console.error(e); }
})();
})();
